module.exports = __webpack_public_path__ + "media/images/header/impact-15c27bd9dc62fd4bd6eff74cea1b736f.svg";